import { Menu, Select } from "antd";
import type { MenuProps } from "antd";
import PersonIcon from "@/assets/icons/person.svg?react";

type SubjectOption = {
  value: string;
  label: string;
};

type SubjectSidebarProps = {
  subjectsList: SubjectOption[];
  menuItems: MenuProps["items"];
  activeKey: string;
  currentSubjectId: string;
  onSubjectChange: (subjectId: string) => void;
  onMenuSelect: (key: string) => void;
  /** Rendered inside the subject card, under the selector — e.g. the
   * profile-review control. The card grows to fit it. */
  extra?: React.ReactNode;
};

export default function SubjectSidebar({
  subjectsList,
  menuItems,
  activeKey,
  currentSubjectId,
  onSubjectChange,
  onMenuSelect,
  extra,
}: SubjectSidebarProps) {
  return (
    <div className="ssj-sidebar w-[280px] min-w-[280px] sticky top-0 self-start h-screen flex flex-col gap-2 p-3 pb-6 overflow-y-auto">
      {/* Subject selector card */}
      <div
        className="flex flex-col"
        style={{
          borderRadius: 8,
          border: "1px solid rgba(0, 0, 0, 0.04)",
          background: "#FFF",
          boxShadow: "0 2px 15px 4px rgba(0, 0, 0, 0.02)",
        }}
      >
        <div className="h-[54px] pl-3 pr-2 py-3 flex items-center gap-3">
          <div className="flex items-center p-[6px] rounded-[4px] bg-[#2B4752] text-white icon-small">
            <PersonIcon width={26} height={26} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[10px] text-[#556C75] font-semibold tracking-wide leading-tight ml-[7px]">
              SUBJECT
            </div>
            <Select
              value={currentSubjectId}
              className="w-full"
              data-testid="subject-sidebar-select"
              options={subjectsList}
              onChange={onSubjectChange}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              size="small"
              variant="borderless"
            />
          </div>
        </div>
        {extra && (
          <div className="border-t border-black/5 px-3 py-2">{extra}</div>
        )}
      </div>

      {/* Navigation menu card */}
      <div
        className="overflow-y-auto overflow-clip"
        style={{
          borderRadius: 8,
          border: "1px solid rgba(0, 0, 0, 0.04)",
          background: "#FFF",
          boxShadow: "0 2px 15px 4px rgba(0, 0, 0, 0.02)",
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={[activeKey]}
          items={menuItems}
          onClick={({ key }) => onMenuSelect(key)}
          style={{ borderRight: "none", background: "transparent" }}
        />
      </div>
    </div>
  );
}
